import * as React from 'react';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import StyledRotaingPlain from './styles';
const speed = 1.2;
const RotaingPlain = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, className, }) => {
    return (React.createElement(StyledRotaingPlain, { className: className, size: size, color: color, speed: speed }));
};
export default RotaingPlain;
//# sourceMappingURL=index.js.map